require('./vendor/jquery.hoverIntent');
require('jquery-confirm');
require('lity');
// require('./cookie.js');

var viewportWidth = window.innerWidth;
var allVideos;

jQuery(document).ready(function ($) {

	viewportWidth = window.innerWidth;
	window.requestAnimationFrame(scrollHandler);
	window.requestAnimationFrame(resizeHandler);

	// hide success alert
	if ( $('.alert-success').length ) {
		setTimeout(function(){
			$('.alert-success').slideUp();
		}, 4000);
	}

	$('.form_style :required').prev('label').addClass('required');

	// STYLED SELECT BOXES //
	$('.form_style select, .styled_select').each(function(){
		if (!$(this).parent().hasClass('select_wrapper')) {
			$(this).wrap('<div class="select_wrapper"></div>');
		}
	});

	// wrap tables
	$('table').each(function () {
		$(this).wrap('<div class="table_wrapper"></div>');
	});

	// RESPONSIVE VIDEO
	allVideos = $("iframe[src^='https://www.youtube'], iframe[src^='//www.youtube'], iframe[src^='https://player.vimeo.com'], iframe[src^='//player.vimeo.com']");
	// Figure out and save aspect ratio for each video
	allVideos.each(function() {

		var the_width = $(this).width();
		var the_height = $(this).height();

			$(this)
			.attr('data-aspectratio', the_height / the_width)
			.attr('data-maxwidth', the_width)
			.attr('data-maxheight', the_height)
			.css('max-width','100%');

	});
	fluidVideos();

	$('.video video').click(function () {
		if (this.paused) {
			$(this).parent().removeClass('paused').addClass('playing');
			this.play();
			this.addEventListener('ended', function () {
				$(this).parent().addClass('paused').removeClass('playing');
			},false);
    	} else {
			$(this).parent().addClass('paused').removeClass('playing');
			this.pause();
		}
	});

	jconfirm.defaults = {
		draggable: false,
		useBootstrap: false,
		boxWidth: '50rem',
		type: 'primary',
		typeAnimated: false
	};

	$('#alertexample').click(function () {
		$.alert({
			title: 'Great!',
			content: 'This is a demo alert',
			buttons: {
				Cancel: {
					text: 'Cancel',
					action: function () {

					}
				},
				OK: {
					text: 'Continue',
					btnClass: 'btn-primary',
					action: function () {

					}
				}
			}
		});
	});

	// DO NOT CHANGE - trigger function when window scrolls
	$(window).scroll(function () {
		window.requestAnimationFrame(scrollHandler);
	});

	// DO NOT CHANGE - trigger function when window resizes
	$(window).resize(function() {
		window.requestAnimationFrame(resizeHandler);
	});

	// DO NOT CHANGE - trigger function when mouse moves
	$(document).on('mousemove',function(e){
		xpos = e.clientX;
		ypos = e.clientY;
		window.requestAnimationFrame(mouseHandler);
    });

	function resizeHandler() {
		viewportWidth = window.innerWidth;
	}

});

function scrollHandler() {
	var topOfViewport = $(window).scrollTop();
	var bottomOfViewport = topOfViewport + $(window).height();
}


function mouseHandler() {
}

function fluidVideos() {
	// Resize all videos according to their own aspect ratio
	allVideos.each(function() {
		var $el = $(this);
		var newWidth = $(this).parent().width();
		$el
			.width(newWidth)
			.height(newWidth * $el.data('aspectratio'));
	});
}

jQuery(document).ready(function ($) {
    var algoliasearch = require('algoliasearch');
    var autocomplete = require('autocomplete.js');
    //var client = algoliasearch('DGL2HEF6KI', '83892781db0a239b2cfa31f0782e6fd5');
    var client = algoliasearch('NKU45FT9SQ', '4a7ef31cb7c0bcee540525ec1168911c');
    var index = client.initIndex('fpe_part_numbers');
    var sales_part_results = 0;
    var search_query = '';
    var exact_match_count = 0;
    var search = autocomplete('#desktop_search, #mobile_search',
        {
            hint: false,
            debug: true,
            minLength: 3,
            debounce: 500
        },
        [
            {
                source: function (query, callback) {
                    search_query = query;
                    var customer_number = $('#desktop_search').data('customer-number');
                    var filters = 'sales_part_numbers.customer_id:0';
                    if (customer_number != '0' && customer_number != null && customer_number != '') {
                        filters = filters + ' OR sales_part_numbers.customer_id:' + customer_number;
                    }
                    var searchableAttributes = ['sales_part_numbers.spn_part_number'];
                    index.search(query, {
                        hitsPerPage: 5,
                        restrictSearchableAttributes: searchableAttributes,
                        filters: '('+filters+')'
                    }).then(function (answer) {
                        callback(answer.hits);
                        sales_part_results = answer.nbHits;
                    }, function () {
                        callback([]);
                    });
                },
                //value to be displayed in input control after user's suggestion selection
                displayKey: 'part_number',
                //hash of templates used when rendering dataset
                templates: {
                    //'suggestion' templating function used to render a single suggestion
                    suggestion: function (suggestion) {
                        // find the matching sales part number
                        var customer_number = $('#desktop_search').data('customer-number');
                        var highlight = '';
                        var match = '';
                        var strippedMatch = ''
                        suggestion._highlightResult.sales_part_numbers.forEach(function (item, index) {
                            if (item.spn_part_number.matchLevel == 'full') {
                                    match = item.spn_part_number.value.trim();
                                    strippedMatch = match.replace(/<[^>]*>/g, '');
                                    highlight = suggestion.part_number + ' (' + item.spn_part_number.value + ')';
                            }
                        });
                        if (strippedMatch == search_query) {
                            exact_match_count++;
                            return "<span class='aa-single-result'><a href='/search?q=" +  strippedMatch + "'><span class='exact'>" + highlight +"</span></a></span>";
                        } else {
                            return "<span class='aa-single-result'><a href='/search?q=" + suggestion.part_number + "'><span class='full'>" + highlight + "</span></a></span>";
                        }
                    },
                    footer: function (query) {
                        return "<span class='see_all'><a href='/search?q=" + query.query + "'>See all results</a></span>";
                    }
                }
            },
            {
                source: function (query, callback) {
                    setTimeout(
                        function () {
                            var searchableAttributes = ['part_number'];
                            if (exact_match_count == 0) {
                                index.search(query, {
                                    hitsPerPage: 5,
                                    restrictSearchableAttributes: searchableAttributes
                                }).then(function (answer) {
                                    callback(answer.hits);
                                }, function () {
                                    callback([]);
                                });
                            }
                        }
                    ,100);
                },
                //value to be displayed in input control after user's suggestion selection
                displayKey: 'part_number',
                //hash of templates used when rendering dataset
                templates: {
                    //'suggestion' templating function used to render a single suggestion
                    suggestion: function (suggestion) {
                        if (suggestion.part_number == search_query) {
                            return "<span class='aa-single-result'><a href='/search?q=" + suggestion.part_number + "&exact=true'><span class='exact'><em>" + suggestion._highlightResult.part_number.value + "</em></span></a></span>";
                        } else {
                            return "<span class='aa-single-result'><a href='/search?q=" + suggestion.part_number + "&exact=true'><span class='" + suggestion._highlightResult.part_number.matchLevel + "'>" + suggestion._highlightResult.part_number.value + "</span></a></span>";
                        }
                    },
                    footer: function (query) {
                        return "<span class='see_all'><a href='/search?q=" + query.query + "'>See all results</a></span>";
                    }
                }
            }
        ]).on('autocomplete:selected', function (event, suggestion, dataset) {
            window.location.href = "/search?q=" + suggestion.part_number + "&exact=true";
        }
    );
    });

    document.addEventListener('DOMContentLoaded', function() {
        const isMobile = window.innerWidth < 1024;
        if (!isMobile) return;
        const items = document.querySelectorAll('.usp-item');
        if (!items.length) return;
        let currentIndex = 0;
        items[0].classList.add('active');
        setInterval(() => {
            items[currentIndex].classList.remove('active');
            currentIndex = (currentIndex + 1) % items.length;
            items[currentIndex].classList.add('active');
        }, 4000);
    });
